<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import {Geolocation} from "@capacitor/geolocation";
import {AndroidSettings, NativeSettings} from "capacitor-native-settings";
import {NeshanMapLeaflet} from 'vuejs-neshan-map-leaflet'
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import {Device} from "@capacitor/device";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "OrdersInformation",
  components: {FooterPage, NavbarPage, NeshanMapLeaflet, LoadingPage},
  setup() {

    let loading = ref(false)
    let data = ref({
      action: 'add',
      state_id: null,
      city_id: null,
      code_posty: '',
      address: '',
      recipient_name: '',
      phone: '',
      lat: null,
      long: null,
    })


    let states = ref([])
    let cities = ref([])

    let latitudee = ref(32.64647475169591)
    let longitudee = ref(51.667747497676835)
    let map = ref(true)
    let options_map = ref({
      key: 'web.1c66e9d7d7704759bb20b5681a167d01',
      maptype: 'dreamy',
      poi: true,
      traffic: false,
      center: [latitudee.value, longitudee.value],
      zoom: 17,
    })

    function get_country() {
      loading.value = true

      FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        states.value = res.data.results
        data.value.state_id = states.value[0]?.id ?? null

        cities.value = states.value[0]?.city ?? []
        data.value.city_id = cities.value[0]?.id ?? null

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }
    get_country()

    function change_state() {
      cities.value = states.value.find((item)=> item.id === data.value.state_id)?.city ?? []
      data.value.city_id = cities.value[0]?.id ?? null
    }

    function getLatitude(latitude) {
      latitudee.value = latitude
      data.value.lat = latitude
      NeshanAddress()
    }

    function getLongitude(longitude) {
      longitudee.value = longitude
      data.value.long = longitude
    }

    function NeshanAddress() {

      axios.get('https://api.neshan.org/v5/reverse', {
        headers: {
          'api-key': 'service.351d16346f8a4e5f98b062a0cb16a8c9'
        },
        params: {
          lat: latitudee.value,
          lng: longitudee.value,
        }

      }).then((response) => {
        data.value.address = response.data.formatted_address
        map.value = true
      }).catch((result) => {
        map.value = true
        Swals.Catch(result, NeshanAddress)
      })
    }

    NeshanAddress()

    async function getCurrentPosition() {
      NeshanAddress()

      let deviceInfo = await Device.getInfo()
      let device = deviceInfo.platform

      if (device === 'android') {

        Geolocation.checkPermissions().then((res) => {

          if (res.location == 'granted') {
            Geolocation.getCurrentPosition().then((pos) => {
              map.value = false
              latitudee.value = pos.coords.latitude
              longitudee.value = pos.coords.longitude
              options_map.value.center = [latitudee.value, longitudee.value]
              NeshanAddress()
              // setTimeout(() => {
              //   map.value = true
              // }, 100)
            })

          } else {
            Geolocation.requestPermissions()
          }

        }).catch(() => {
          Swal.fire({
            icon: 'question',
            iconColor: '#ff5b5b',
            text: 'موقعیت یاب دستگاه روشن شود؟',
            width: 250,
            color: '#000000',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'بله',
            cancelButtonText: 'خیر',
            confirmButtonColor: '#71ea90',
            cancelButtonColor: '#fc6969',
            background: 'white',
          }).then((result) => {
            if (result.isConfirmed) {
              NativeSettings.openAndroid({
                option: AndroidSettings.Location,
              });
            }
          })

        })

      } else {
        navigator.geolocation.getCurrentPosition((pos) => {
          map.value = false
          latitudee.value = pos.coords.latitude
          longitudee.value = pos.coords.longitude
          options_map.value.center = [latitudee.value, longitudee.value]

          NeshanAddress()
        }, () => {
          Swals.Fault('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
        });
      }

    }

    function add_address() {

      if (data.value.recipient_name.trim().length === 0) {

        Swal.fire({
          text: "لطفا نام گیرنده را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

        return false
      }
      if (data.value.phone.length === 0) {

        Swal.fire({
          text: "لطفا شماره همراه خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }
      if (data.value.phone.length !== 11 || data.value.phone.charAt(0) !== '0' || data.value.phone.charAt(1) !== '9') {
        Swal.fire({
          text: "لطفا شماره همراه خود را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }
      if (data.value.code_posty.length !== 10) {

        Swal.fire({
          text: "لطفا کد پستی خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }
      if (data.value.address.trim().length === 0) {

        Swal.fire({
          text: "لطفا آدرس خود را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }

      data.value.lat = latitudee.value
      data.value.lng = longitudee.value

      loading.value = true

      FreeWorld.Heisenberg(data.value, 'user_address', true).then((res) => {

        loading.value = false
        if (res.data.status === 'ok') {
          Swals.Done('آدرس مورد نظر شما با موفقیت اصافه شد' , 'OrdersInformation')
        } else {
          Swals.Fault('متاسفانه آدرس مورد نظر شما اضافه نشد!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_address)
      })

    }

    return {
      loading,
      getLongitude,
      getLatitude,
      getCurrentPosition,
      add_address,
      data,
      options_map,
      map,
      states,
      cities,
      change_state,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div :class="loading ? 'activeClass' : '' " id="main" class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          افزودن ادرس جدید
        </p>
        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body mt-2">

      <div class="w-100">
        <p class="font-4 mb-2 font-bold text-end">
          نام گیرنده :
        </p>

        <input v-model="data.recipient_name" class="p-3 font-4 bg-white w-100 border-costom rounded-3"
               type="text">
      </div>

      <hr>

      <div class="w-100">
        <p class="font-4 mb-2 font-bold text-end">
          استان :
        </p>

        <select v-model="data.state_id" @change="change_state" class="p-3 bg-white w-100 border-costom font-4 text-center rounded-3">
          <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <hr>

      <div class="w-100">
        <p class="font-4 mb-2 font-bold text-end">
          شهر :
        </p>

        <select v-model="data.city_id" class="p-3 bg-white w-100 border-costom font-4 text-center rounded-3">
          <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <hr>

      <div class="w-100">
        <p class="font-4 mb-2 font-bold text-end">
          شماره تلفن :
        </p>

        <input v-model="data.phone" maxlength="11"
               class="p-3 bg-white w-100 text-center font-4 border-costom rounded-3 mb-2 bg-white" type="tel">

      </div>

      <hr>

      <div class="w-100">
        <p class="font-4 mb-2 font-bold text-end">
          کد پستی :
        </p>

        <input v-model="data.code_posty" class="p-3 bg-white font-4 w-100 text-center border-costom rounded-3"
               maxlength="10" type="text"
               onkeydown="return event.key != ' '">
      </div>

      <hr>

      <div class="w-100">
        <p class="font-4 font-bold mb-2 text-end">
          آدرس گیرنده :
        </p>
        <p class="font-5 mb-2 text-end">
          جزئیات را به صورت دقیق و کامل شرح دهید
        </p>
      </div>

      <div style="height: 25rem" class="w-100 my-4 position-relative">

        <NeshanMapLeaflet
            v-if="map"
            class="w-100 h-100 rounded-4"
            :options="options_map"
            @latitude="getLatitude"
            @longitude="getLongitude"
        />
        <div @click="getCurrentPosition()" class="bg-gray rounded-3"
             style="position: absolute;bottom: .5rem;right: .5rem;z-index: 1000">
          <img src="../assets/img/location.svg"
               style="width: 3.1rem;height: 3.1rem" rel="loc">
        </div>

      </div>

      <textarea v-model="data.address" dir="rtl"
                class="textarea_users font-4 w-100 border-costom p-2 bg-white rounded-4"></textarea>

    </div>

    <div class="button_div w-100 d-flex justify-content-center p-body">
      <v-btn @click="add_address"
             class="w-100 h-75 font-4 mx-4 bg-color rounded-pill border-costom text-white my-2">
        ثبت آدرس
      </v-btn>
    </div>
  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-3 w-75 ma-auto">افزودن آدرس</div>

    <div class="w-75 ma-auto animate__animated animate__fadeIn bg-white p-5 rounded-4">

      <div class="p-body mt-2">

        <div class="w-100">
          <p class="font-4 mb-2 font-bold text-end">
            نام گیرنده :
          </p>

          <input v-model="data.recipient_name" class="p-3 shadow font-4 bg-white w-100 border-costom rounded-3"
                 type="text">
        </div>

        <hr>

        <div class="w-100">
          <p class="font-4 mb-2 font-bold text-end">
            استان :
          </p>

          <select v-model="data.state_id" @change="change_state" class="p-3 shadow bg-white w-100 border-costom font-4 text-center rounded-3">
            <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <hr>

        <div class="w-100">
          <p class="font-4 mb-2 font-bold text-end">
            شهر :
          </p>

          <select v-model="data.city_id" class="p-3 shadow bg-white w-100 border-costom font-4 text-center rounded-3">
            <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <hr>

        <div class="w-100">
          <p class="font-4 mb-2 font-bold text-end">
            شماره تلفن :
          </p>

          <input v-model="data.phone" maxlength="11"
                 class="p-3 bg-white shadow w-100 text-center font-4 border-costom rounded-3 mb-2 bg-white" type="tel">

        </div>

        <hr>

        <div class="w-100">
          <p class="font-4 mb-2 font-bold text-end">
            کد پستی :
          </p>

          <input v-model="data.code_posty" class="p-3 shadow bg-white font-4 w-100 text-center border-costom rounded-3"
                 maxlength="10" type="text"
                 onkeydown="return event.key != ' '">
        </div>

        <hr>

        <div class="w-100">
          <p class="font-4 font-bold mb-2 text-end">
            آدرس گیرنده :
          </p>
          <p class="font-5 mb-2 text-end">
            جزئیات را به صورت دقیق و کامل شرح دهید
          </p>
        </div>

        <div style="height: 25rem" class="w-100 my-4 position-relative">

          <NeshanMapLeaflet
              v-if="map"
              class="w-100 h-100 rounded-4"
              :options="options_map"
              @latitude="getLatitude"
              @longitude="getLongitude"
          />
          <div @click="getCurrentPosition()" class="bg-gray rounded-3"
               style="position: absolute;bottom: .5rem;right: .5rem;z-index: 1000">
            <img src="../assets/img/location.svg"
                 style="width: 3.1rem;height: 3.1rem" rel="loc">
          </div>

        </div>

        <textarea v-model="data.address" dir="rtl"
                  class="textarea_users font-4 shadow w-100 border-costom p-2 bg-white rounded-4"></textarea>

      </div>

      <br>
      <br>

      <div class="button_div_web p-body w-75 ma-auto d-flex justify-content-center">
        <v-btn @click="add_address" class="w-100 h-100 mx-4 bg-color rounded-pill border-costom text-white my-2">
          پرداخت و ثبت نهایی
        </v-btn>
      </div>
    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>
.textarea_users {
  height: 9.4rem;
  resize: none;
}

.button_div {
  height: 6rem;
}

.button_div_web {
  height: 60px;
}
</style>